import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FaDiscord, FaFacebook, FaGitlab, FaLinkedin } from 'react-icons/fa'

import { useAuth } from '@/auth/useAuth'
import { env } from '@/config/env'
import { StaticPagesRoutes } from '@/routes/_hooks/routes.enum'
import { useAddProfileDialogStore } from '@/stores/addProfileDialogStore'

export interface LinkGroup {
  title: string
  links: Array<{
    label: string
    /** Navigation target. Omitted for action links (see `onClick`). */
    href?: string
    /** When set, the link behaves as a button instead of navigating. */
    onClick?: () => void
    badge?: React.ReactElement
  }>
}
export interface SocialLink {
  label: string
  icon: React.ReactElement
  href: string
}

export type FooterLink = {
  label: string
  href: string
}

export const useLinks = (): LinkGroup[] => {
  const { t } = useTranslation()
  const auth = useAuth()
  const openAddProfileDialog = useAddProfileDialogStore(
    (state) => state.openDialog
  )

  return [
    {
      title: t('layout.footer.links.aboutUs.title'),
      links: [
        {
          label: t('layout.footer.links.aboutUs.team'),
          href: StaticPagesRoutes.Team,
        },
        /* {
                    label: t('layout.footer.links.aboutUs.careers.label'),
                    href: '#',
                    badge: (
                        <Box className={'light'}>
                            <Badge colorPalette="blue" fontSize="0.625rem">
                                {t(
                                    'layout.footer.links.aboutUs.careers.notHiring'
                                )}
                            </Badge>
                        </Box>
                    ),
                 }, */
        { label: t('layout.footer.links.aboutUs.press'), href: '#' },
        { label: t('layout.footer.links.aboutUs.faq'), href: '#' },
      ],
    },
    {
      title: t('layout.footer.links.product.title'),
      links: [
        ...(auth.user
          ? [
              {
                label: t('layout.footer.links.product.addProfile'),
                onClick: openAddProfileDialog,
              },
            ]
          : []),
        {
          label: t('layout.footer.links.product.howItWorks'),
          href: '#',
        },
        {
          label: t('layout.footer.links.product.contribute'),
          href: StaticPagesRoutes.Contribute,
        },
        {
          label: t('layout.footer.links.product.privacy'),
          href: StaticPagesRoutes.Privacy,
        },
        {
          label: t('layout.footer.links.product.terms'),
          href: StaticPagesRoutes.Terms,
        },
      ],
    },
    {
      title: t('layout.footer.links.resources.title'),
      links: [
        { label: t('layout.footer.links.resources.blog'), href: '#' },
        {
          label: t('layout.footer.links.resources.sponsors'),
          href: '#',
        },
        { label: t('layout.footer.links.resources.help'), href: '#' },
      ],
    },
    {
      title: t('layout.footer.links.contact.title'),
      links: [
        {
          label: t('layout.footer.links.contact.form'),
          href: StaticPagesRoutes.Contact,
        },
        ...(env.DISCORD_INVITATION_LINK
          ? [
              {
                label: t('layout.footer.links.contact.discord'),
                href: env.DISCORD_INVITATION_LINK,
              },
            ]
          : []),
        ...(env.CONTACT_EMAIL
          ? [
              {
                label: env.CONTACT_EMAIL,
                href: `mailto:${env.CONTACT_EMAIL}`,
              },
            ]
          : []),
      ],
    },
  ]
}

export const useSocialLinks = (): SocialLink[] => {
  const { t } = useTranslation()
  return [
    ...(env.DISCORD_INVITATION_LINK
      ? [
          {
            label: t('layout.footer.links.social.discord'),
            icon: <FaDiscord />,
            href: env.DISCORD_INVITATION_LINK,
          },
        ]
      : []),
    ...(env.FACEBOOK_LINK
      ? [
          {
            label: t('layout.footer.links.social.facebook'),
            icon: <FaFacebook />,
            href: env.FACEBOOK_LINK,
          },
        ]
      : []),
    ...(env.LINKEDIN_LINK
      ? [
          {
            label: t('layout.footer.links.social.linkedin'),
            icon: <FaLinkedin />,
            href: env.LINKEDIN_LINK,
          },
        ]
      : []),
    ...(env.GITLAB_LINK
      ? [
          {
            label: t('layout.footer.links.social.linkedin'),
            icon: <FaGitlab />,
            href: env.GITLAB_LINK,
          },
        ]
      : []),
  ]
}

export const useExtraFooterLinks = (): FooterLink[] => {
  return []
}
